module.exports = __webpack_public_path__ + "static/media/limitedTimeOffers.mobile.6bc3c9f8.svg";